import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { CollapseTransition } from '@ivanv/vue-collapse-transition';
import useProductContent from '@/composables/useProductContent/useProductContent';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default defineComponent({
  name: 'ItemCategorizedTab',
  components: {
    CollapseTransition: CollapseTransition,
    AzIcon: AzIcon,
    RenderContent: function RenderContent() {
      return import('~/components/cms/page/RenderContent.vue');
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subCategoryText: {
      type: String,
      default: ''
    },
    contents: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    category: {
      type: Object,
      default: function _default() {}
    }
  },
  setup: function setup(props) {
    var _useProductContent = useProductContent(),
      mapComponentName = _useProductContent.mapComponentName;
    var components = computed(function () {
      return props.contents.length ? mapComponentName(props.contents) : null;
    });
    var isContentEmpty = computed(function () {
      var _components$value;
      return !((_components$value = components.value) !== null && _components$value !== void 0 && _components$value.length);
    });
    var isContentExpanded = ref(true);
    provide('isContentExpanded', isContentExpanded.value);
    var toggleExpandContent = function toggleExpandContent() {
      if (!isContentEmpty.value) {
        isContentExpanded.value = !isContentExpanded.value;
      }
    };
    var checkCategory = computed(function () {
      var _props$category$field;
      return (_props$category$field = props.category.fields) === null || _props$category$field === void 0 ? void 0 : _props$category$field.category;
    });
    onMounted(function () {
      isContentExpanded.value = false;
    });
    return {
      components: components,
      isContentExpanded: isContentExpanded,
      toggleExpandContent: toggleExpandContent,
      isContentEmpty: isContentEmpty,
      checkCategory: checkCategory
    };
  }
});